jQuery(function ($) {

 

    $(window).on("click", function() {
        $('#menu-residents-main-menu .active').removeClass('active');
        $('#menu-visitors-main-menu .active').removeClass('active');
      });
      
      $('#menu-residents-main-menu').on("click", function(event){
        event.stopPropagation();
      });
      $('#menu-visitors-main-menu').on("click", function(event){
        event.stopPropagation();
      });




    $('#menu-residents-main-menu .active').removeClass('active');
    $('#menu-visitors-main-menu .active').removeClass('active');

    // This duplicates the parent title into the child menu on residents menu
    $('#menu-residents-main-menu .submenu li:first-child').each(function () {
        var parent = $(this).parent('ul').parent('.menu-item-has-children');
        var copy = parent.clone();
        $(copy).removeClass('menu-item-has-children').find('.submenu').remove();

        $('.menu-item-has-children').removeAttr('style');
        $(copy).addClass('col header mobile-only');
        $(this).before(copy);
    });
    

    // This creates the first column on the visitors megamenu however it is not accessible
    // $('#menu-visitors-main-menu .top-level').each(function () {
    //     var divider = $(this).siblings('ul').children('li').not(':first-child');
    //     $(divider).wrapAll('<div class="col stacked" />');
    // });

    // This creates the large image to right on dropdown menu
    $('#menu-visitors-main-menu .submenu .stacked .largeimage').each(function () {
        var parent = $(this).parent('stacked').parent('ul');
        var dup = $(this).clone();
        $(this).parent('.stacked').after(dup);
        $(this).remove();
    });

    // Make links with children unclickable
    // $('#menu-visitors-main-menu .menu-item-has-children > a').attr('href' ,'#');
    // $('#menu-residents-main-menu .menu-item-has-children > a').attr('href' ,'#');

    // $('#menu-residents-main-menu > .menu-item-has-children > a').on('click', function(event){
    //     event.preventDefault();
    // });

    // $('.menu-item-has-children > a, .menu-item-has-children > a').off("click").on("click", function(event){
    //     event.preventDefault();
    // });

    //removed load and added trigger to load on ready insead
    $(window)
        .on('resize', function () {
            $('#menu-residents-main-menu .active').removeClass('active');
            $('#menu-visitors-main-menu .active').removeClass('active');

            if ($(window).width() > 991) {
                if ($('.panel-close').length === 0) {
                } else {
                    $('.panel-close').closest('li').remove();
                }

                //reset menu on resize residents
                $('#menu-residents-main-menu').each(function () {
                    $('.megamenu').removeClass('submenu-open');
                    $('.megamenu').removeClass('submenu-animate');
                    $('.megamenu').removeClass('submenu-close');
                });
                //reset menu on resize visitors
                $('#menu-visitors-main-menu').each(function () {
                    $('.submenu').removeClass('submenu-open');
                    $('.submenu').removeClass('submenu-animate');
                    $('.submenu').removeClass('submenu-close');
                    $('.largeimage').removeClass('hide');
                });

                //Residents Desktop Behavior
                $('#menu-residents-main-menu > .menu-item-has-children')
                    .off('click')
                    .on('click', function (event) {
                        $(this).find('.top-level').toggleClass('active');
                        $(this).find('.top-level').siblings('.megamenu').toggleClass('active');
                        $(this).siblings('.menu-item-has-children').find('.megamenu:first').removeClass('active');
                        $(this).siblings('.menu-item-has-children').find('a:first').removeClass('active');
                    });
                $('#menu-residents-main-menu > .menu-item-has-children > a')
                    .off('click')
                    .on('click', function (event) {
                        event.preventDefault();
                    });

                //Visitor Desktop behavior
                $('#menu-visitors-main-menu .menu-item-has-children .top-level')
                    .off('click')
                    .on('click', function (event) {
                        event.preventDefault();
                        // open and add active to tab
                        $(this).toggleClass('active');
                        $(this).siblings('ul').toggleClass('active');

                        //close all other tabs and remove active
                        $(this).parent('li').siblings().find('.second-level').removeClass('active');
                        $(this).parent('li').siblings().find('.stacked .submenu').removeClass('submenu-open');
                        $(this).parent('li').siblings().find('.removelink').removeClass('hide');
                        $(this).parent('li').siblings().find('.top-level').removeClass('active');
                        $(this).parent('li').siblings().find('.megamenu').removeClass('active');
                    });

                $('#menu-visitors-main-menu .menu-item-has-children > .second-level')
                    .off('click')
                    .on('click', function (event) {
                        $(this).parent('li').siblings().find('.second-level').removeClass('active');
                        $(this).toggleClass('active');
                        $(this)
                            .parent('li')
                            .siblings()
                            .find('.submenu')
                            .removeClass('submenu-open submenu-animate submenu-close');
                        $(this).parents('.stacked').parent('ul').find('.largeimage').toggleClass('hide');
                        $(this)
                            .siblings('.submenu')
                            .first()
                            .toggleClass('submenu-open submenu-animate')
                            .removeClass('submenu-close');
                        event.preventDefault();
                    });
            } else if ($(window).width() < 991) {
                $('#sm_menu_ham')
                    .off('click')
                    .on('click', function (event) {
                        $('.nav-container').toggleClass('active');
                        $('body').toggleClass('removescroll');
                        $(this).toggleClass('open');
                        $('#logo-mobile').toggleClass('open');
                        //close search if menu is toggled
                        $('#search-dropdown').slideUp('fast');
                        $('#open-search, #open-search-mobile').removeClass('open');
                    });

                // reset classes on ready
                $('.menu-item-has-children').removeClass('active');
                $('.megamenu').removeClass('active');
                $('.megamenu').removeClass('submenu-open');
                $('.megamenu').removeClass('submenu-animate');
                $('.megamenu').removeClass('submenu-close');

                $('.menu-item-has-children > a')
                    .off('click')
                    .on('click', function (event) {
                        event.preventDefault();
                        var el = $(this).parent('.menu-item-has-children').find('.submenu');
                        $(el).first().addClass('submenu-open submenu-animate').removeClass('submenu-close');
                        var anchor = $('.submenu');
                        $(anchor).scrollTop(0);
                    });

                $('#menu-visitors-main-menu a.third-level')
                    .off('click')
                    .on('click', function (event) {
                        event.preventDefault();
                    });
                $('#menu-visitors-main-menu a.third-level').each(function () {
                    $(this).parent('li').addClass('label');
                });

                //this restores the click through for hotels on mobile 3rd level
                $('#menu-visitors-main-menu #menu-item-580 a.third-level')
                .off('click')
                .on('click', function (event) {
                    return true;
                });

                // $('.top-level').off('click').on('click', function(){
                //     $(this).parent('.menu-item-has-children').find('.submenu').first().addClass('submenu-open submenu-animate').removeClass('submenu-close');
                // });

                // $('.second-level').off('click').on('click', function(){
                //     $(this).parent('.menu-item-has-children').find('.submenu').first().addClass('submenu-open submenu-animate').removeClass('submenu-close');
                // });

                if ($('.panel-close').length === 0) {
                    $("<li><a class='panel-close' href='#'>Back</a></li>").prependTo('.submenu');
                } else {
                }

                //updated from below body on click - not sure why it was done that way to start, but it was left because maybe there was a reason
                $('.panel-close').on("click", function(){
                    $(this)
                            .closest('.submenu')
                            .first()
                            .removeClass('submenu-open')
                           .addClass('submenu-close submenu-animate');
                });

                // $('body').on('click', '.panel-close', function () {
                //     $(this)
                //         .closest('.submenu')
                //         .first()
                //         .removeClass('submenu-open')
                //         .addClass('submenu-close submenu-animate');
                // });
            }
        })
        .trigger('resize');

    $('#open-search, #open-search-mobile').on('click', function (e) {
        e.preventDefault();
        $('#search-dropdown').slideDown('fast');
        $(this).addClass('open');
    });

    $('#close-search').on('click', function () {
        $('#search-dropdown').slideUp('fast');
        $('#open-search, #open-search-mobile').removeClass('open');
    });
});
